import ProCard from './pro-card';
export default ProCard;
